import { createApp } from "vue/dist/vue.esm-bundler.js"
import { createPinia } from 'pinia'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import App from '../components/App.vue'
import '../utils/sw-manager.js' // 初始化 Service Worker
import '../styles/tailwind.css' // Import Tailwind CSS

const app = createApp(App)
const pinia = createPinia()

// 安裝 Pinia
app.use(pinia)

// 註冊 DynamicScroller 和 DynamicScrollerItem 組件
app.component('DynamicScroller', DynamicScroller)
app.component('DynamicScrollerItem', DynamicScrollerItem)

app.mount('#app')

app.config.errorHandler = (err) => {
  /* 錯誤處理 */
  console.log(err)
}